import React from 'react'
import { useState } from 'react'

const AccordionFaq = (props) => {
    const [Toogle, setToogle] = useState(false)
    return (
        <div className={"wrapper__accordion-faq " + (Toogle ? "active" : "")}>
            <div className="head pointer" onClick={() => setToogle(!Toogle)}>
                <h4 className='mb-0 semi-bold font__size--20 text__20-1024'>{props.data.title}</h4>
                <div className="arrow">
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div className="body">
                <p className='normal font__size-14 text__14-1024 mb-0 color__gray-1'>{props.data.desc}</p>
            </div>
        </div>
    )
}

export default AccordionFaq